import React from 'react';
import DataTableWithButton from '../../shared/component/dataTable/DataTableWithButton';

const CHEAPER_COST_HIGHLIGHT = '#e81123';

const STATUS_LABELS = {
    MATCHED: 'Matched',
    SHORT: 'Short delivery',
    OVER: 'Over delivery',
    MISSING: 'Missing on DN',
    UNEXPECTED: 'Not on PO'
};

export default class PurchaseRequisitionItemDataTable extends DataTableWithButton {
    getMoneyCellHighlight = (rowData, column) => {
        if (column.field === 'currentCost' && rowData.cheaperCostAvailable === true) {
            return CHEAPER_COST_HIGHLIGHT;
        }
        return null;
    };

    getDeliveryCompareTone = (matchStatus) => {
        if (matchStatus === 'SHORT' || matchStatus === 'MISSING' || matchStatus === 'UNEXPECTED') {
            return 'short';
        }
        if (matchStatus === 'OVER') {
            return 'over';
        }
        return null;
    };

    deliveryCompareStatusBody = (rowData) => {
        const status = rowData?.matchStatus;
        const label = (rowData && STATUS_LABELS[status]) || status || '';
        const tone = this.getDeliveryCompareTone(status);
        if (!tone) {
            return <span>{label}</span>;
        }
        return <span className={`dn-compare-chip dn-compare-chip--${tone}`}>{label}</span>;
    };

    deliveryCompareWarningBody = (rowData) => {
        const warning = rowData?.warning || '';
        const tone = this.getDeliveryCompareTone(rowData?.matchStatus);
        if (!warning) {
            return <span>—</span>;
        }
        if (!tone) {
            return <span title={warning}>{warning}</span>;
        }
        return (
            <span className={`dn-compare-warning dn-compare-warning--${tone}`} title={warning}>
                {warning}
            </span>
        );
    };

    deliveryCompareDamagedBody = (rowData) => {
        const damaged = Number(rowData?.damagedQty);
        const display = rowData?.damagedQty == null || rowData?.damagedQty === '' ? 0 : rowData.damagedQty;
        const isAlert = !Number.isNaN(damaged) && damaged > 0;
        return (
            <span className={isAlert ? 'dn-compare-damaged dn-compare-damaged--alert' : ''}>
                {display}
            </span>
        );
    };
}
